import script from "./DeviceByTypeCreateForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeviceByTypeCreateForm.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__